var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M4.816 14.367h10.368a.816.816 0 0 1 .102 1.627l-.102.006H4.816a.816.816 0 0 1-.102-1.627l.102-.006h10.368zM10 3c.417 0 .76.312.81.714l.007.103v7.475l1.493-1.493a.817.817 0 1 1 1.155 1.155l-2.887 2.888a.817.817 0 0 1-1.155 0l-2.888-2.888A.817.817 0 1 1 7.69 9.8l1.493 1.493V3.817c0-.451.366-.817.817-.817z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDownload);
export default __webpack_public_path__ + "static/media/btn-download.1674847de09ca3703d2bb9789e4b4ef9.svg";
export { ForwardRef as ReactComponent };